import './areas.scss';

const Areas = ({ areas }) => (
  <section className="areas">
    <div className="container">
      <h2 className="section-title">Areas We Serve</h2>

      <ul>
        {areas?.map((area, index) => (
          <li key={index}>{area.location}</li>
        ))}
      </ul>
    </div>
  </section>
);

export default Areas;
